export default __webpack_public_path__ + "static/media/gauge-empty.3ef637c4.svg";